export const stripeBillingQueryKeys = {
  all: (slug: string) => [slug, 'stripe', 'billing'] as const,
  paymentMethodStatus: (slug: string) =>
    [...stripeBillingQueryKeys.all(slug), 'payment-method-status'] as const,
  paymentMethods: (slug: string) =>
    [...stripeBillingQueryKeys.all(slug), 'payment-methods'] as const
}

export const paymentMethodStatusQueryKey = stripeBillingQueryKeys.paymentMethodStatus
export const paymentMethodsQueryKey = stripeBillingQueryKeys.paymentMethods
